/**
 * Size presets for the product form.
 *
 * order drives sizeOrder on the product: sorting by the size label alone
 * would give L, M, S, XL, XXL, which is not what a shopper expects.
 */
export const SIZE_PRESETS = [
  { label: 'XXS', order: 1 },
  { label: 'XS', order: 2 },
  { label: 'S', order: 3 },
  { label: 'M', order: 4 },
  { label: 'L', order: 5 },
  { label: 'XL', order: 6 },
  { label: 'XXL', order: 7 },
  { label: 'XXXL', order: 8 },
];

export const orderForSize = (label) =>
  SIZE_PRESETS.find((s) => s.label === String(label).toUpperCase())?.order ?? '';
